import React from "react";
import { useHistory, Link } from "react-router-dom";
import "./intro.css";
import Breadcrumb from "../common/breadcrumb";
import { Helmet } from "react-helmet";

const intro = () => {
  return (
    <div>
      <Helmet>
        <title>eksplode! | Intro</title>
      </Helmet>
      <Breadcrumb title={"Introduction"} />
      about section
      <section className="about-page  section-b-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="banner-section d-flex justify-content-center">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/mega-menu/.jpeg`}
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
            <div className="col-sm-12">
              <h3>Introduction</h3>

              <p>Welcome to electronic Ad Card (EAC) Program.</p>
              <br />
              <p>
                Eksplode Marketing offers individual 13 and older a unique and
                easy way to earn cash through its EAC program
              </p>
              <p>
                To begin earning cash, just follow these easy steps: 1. Read and
                agree to our Terms and Conditions of Use. 2. Complete our Sign
                Up form and receive your individualized eksplode Code. 3.
                Activate the 'Merchants Club' tab to access your Workshop page,
                then upload your contact list. 4. Access our Merchants' catalogs
                from your Workshop and select products or services you would
                like to promote. 5. Return to your Workshop, customize your
                greeting (or not), then send your EACs to others on your contact
                list. 6. Sit back and watch your earnings eksplode!
              </p>
              <br />
              <strong>
                <h3>eksplode!'s EAC Program Description</h3>
              </strong>
              <ol>
                <li>
                  1. Merchant's upload their catalog onto eksplode's EAC
                  platform and select an amount (in USD or a percentage of the
                  sales price) which they agree to reward an eksplode Member for
                  each item sold through their promotional efforts.
                </li>
                <li>
                  {" "}
                  2. eksplode's unique system then creates an Electronic Ad Card
                  (EAC) for each product or service listed by the Merchant.
                </li>
                <li>
                  3. Each EAC depicts a picture and description of the product
                  or service offered by the Merchant.
                </li>
                <li> 4. Each EAC also has a hyperlink tab.</li>
                <li>Each EAC also has a hyperlink tab.</li>
                <li>
                  5. eksplode Members review each EAC and download those they
                  select to promote onto their eksplode platform.
                </li>
                <li>
                  6. Each EAC downloaded, and every EAC electronically
                  transferred, is encrypted with that Member's eksplode Code,
                  which allows eksplode Marketing to connect each sale made to
                  the Member whose EAC was used to access the Merchant's
                  eksplode catalog.
                </li>
                <li>
                  {" "}
                  7. eksplode Members then share their selected EACs with
                  family, friends, peers, and followers through an electronic
                  transfer.
                </li>
                <li>
                  8. The EAC recipient then activates the hyperlink tab and is
                  taken directly to the Merchant's catalog and the product or
                  service depicted and described on the EAC.
                </li>
                <li>
                  9. If the EAC recipient elects to buy the product or service
                  promoted, or any other product or service from that Merchant's
                  eksplode catalog, the entire transaction is processed through
                  eksplode.
                </li>
                <li>
                  10. In processing the transaction, the price of the product
                  (or service), all applicable sales taxes and other fees
                  (including eksplode's fee of 5%) are calculated and billed to
                  the customer.
                </li>
                <li>
                  11. Once the transaction is complete, eksplode will
                  automatically deduct the reward amount selected by the
                  Merchant and deposit it into the account of the Member who
                  promoted the product and caused the sale to occur.
                </li>
                <li>
                  12. The Merchant will automatically receive a Purchase Notice
                  and the remaining proceeds from the sale will be
                  simultaneously deposited into its account of choice.
                </li>
                <li>
                  13. There is no cost to become an eksplode Merchant, and the
                  rewards and eksplode fees are only deducted if and when a
                  product or service is purchased.
                </li>
              </ol>
            </div>
            <br />
            <br />
            <Link
              to="/register/member"
              className="btn btn-solid mb-3 mt-3 ml-3 float-right"
            >
              Sign up
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default intro;
